<template>
    <v-card :to="to" elevation="0" tile class="main-link-card h-100">
        <h4 class="tit tit--xs mb-14px mb-lg-36px">
            {{ tit }}
        </h4>
        <p class="txt grey--text text--lighten-3 line-height-15 break-keep">
            <slot />
        </p>
        <v-img :src="icon" contain max-width="200" alt="" />
    </v-card>
</template>

<script>
export default {
    props: {
        to: { type: String, default: "" },
        tit: { type: String, default: "" },
        icon: { type: String, default: "" },
    },
    data: () => {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.main-link-card.v-card {
    background-color: transparent;
    padding: 24px;
    position: relative;
    h4 {
        position: relative;
        display: inline-block;
        padding-right: 20px;
        color: #fff;
        transition: 0.15s ease-out;
        &::after {
            content: "";
            display: block;
            position: absolute;
            top: 50%;
            right: 12px;
            transform: translateY(-50%);
            width: 20px;
            height: 16px;
            background-image: url(/images/icon/icon-right-arrow-primary.svg);
            background-position: right center;
            background-size: auto 100%;
            background-repeat: no-repeat;
            opacity: 0;
            visibility: hidden;
            transition: 0.15s ease-out;
        }
    }
    > .v-image {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
    }
}
@media (min-width: 1024px) {
    .main-link-card.v-card {
        padding: 60px 40px;
    }
    .main-link-card:hover h4 {
        color: var(--v-primary-base);
    }
    .main-link-card:hover h4::after {
        right: 0;
        opacity: 1;
        visibility: visible;
    }
}
@media (min-width: 1200px) {
}
</style>
